import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined'
import { Badge, Tooltip } from '@mui/material'
import { useNetwork } from '@/app/network/NetworkProvider'
import { useSync } from '@/features/registrations/SyncProvider'
import { waitingSummary } from '@/features/registrations/waitingSummary'
import styles from './NetworkStatus.module.scss'

/**
 * Connection state beside the Settings button. Offline is a crossed-out cloud,
 * badged with the registrations and check-ins on this device still waiting to sync.
 */
export function NetworkStatus() {
  const { isOnline } = useNetwork()
  const { waiting: registrations, checkInsWaiting } = useSync()
  if (isOnline) return <span className={styles.online}>Online</span>
  const waiting = registrations + checkInsWaiting
  const label = waiting > 0
    ? `Offline. ${waitingSummary(registrations, checkInsWaiting)} waiting to sync.`
    : 'Offline. Registrations and check-ins are saved on this device and sync when you reconnect.'
  return (
    <Tooltip title={label}>
      <span className={styles.offline} role="status" aria-label={label} tabIndex={0}>
        <Badge badgeContent={waiting} max={99} color="warning" className={styles.badge}>
          <CloudOffOutlinedIcon aria-hidden="true" />
        </Badge>
      </span>
    </Tooltip>
  )
}
